import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Dashboard from './components/views/admin/Dashboard';
// import KnowledgeBase from "./components/views/admin/KnowledgeBase";
import DashboardCardExpanded from './components/views/admin/DashboardCardExpanded';
import DashboardCardViews from './components/views/admin/DashboardCardViews';

import Main from './components/layouts/Main';
import MainAdmin from './components/layouts/MainAdmin';
import MainLogin from './components/layouts/MainLogin';

import Login from './components/views/login/Login';
import Forgot from './components/views/login/Forgot';
import Reset from './components/views/login/Reset';
import SecondAuth from './components/views/login/SecondAuth';

import RequireAccountUid from "./services/RequireAccountUid";
import RequireAdminOrRedirect from './services/RequireAdminOrRedirect';
import RequireViewPermission from './services/RequireViewPermission';
import RequireOverviewOrRedirect from './services/RequireOverviewOrRedirect';

class Routing extends Component {
	render() {
		return (
			<Router>
				<Routes>
    			<Route path="/" element={<Navigate to="/dashboard/select" replace />} />
    			<Route path="/dashboard" element={<Navigate to="/dashboard/select" replace />} />

					<Route path="/" element={<MainAdmin />}>
						<Route path="/dashboard/select" element={null} />
					</Route>

			    <Route path="/" element={<MainAdmin />}>
						<Route
							path="/dashboard/admin/*"
							element={<RequireAdminOrRedirect />}
						>
							<Route index element={<Dashboard />} />
							<Route path=":card" element={<RequireViewPermission><DashboardCardExpanded /></RequireViewPermission>} />
							<Route path=":card/:views" element={<RequireViewPermission><DashboardCardViews /></RequireViewPermission>} />
							<Route path=":card/:views/:id" element={<RequireViewPermission><DashboardCardViews /></RequireViewPermission>} />
						</Route>
					</Route>

					<Route path="/" element={<MainAdmin />}>
						<Route
							path="/dashboard/overview/*"
							element={<RequireOverviewOrRedirect />}
						>
							<Route index element={<Dashboard />} />
							<Route path=":card" element={<RequireViewPermission><DashboardCardExpanded /></RequireViewPermission>} />
							<Route path=":card/:views" element={<RequireViewPermission><DashboardCardViews /></RequireViewPermission>} />
							<Route path=":card/:views/:id" element={<RequireViewPermission><DashboardCardViews /></RequireViewPermission>} />
						</Route>
					</Route>

					<Route path="/" element={<MainAdmin />}>
						<Route
							path="/dashboard/:accountUid/*"
							element={<RequireAccountUid />}
						>
							<Route index element={<Dashboard />} />
							<Route path=":card" element={<RequireViewPermission><DashboardCardExpanded /></RequireViewPermission>} />
							<Route path=":card/:views" element={<RequireViewPermission><DashboardCardViews /></RequireViewPermission>} />
							<Route path=":card/:views/:id" element={<RequireViewPermission><DashboardCardViews /></RequireViewPermission>} />
						</Route>
					</Route>

					<Route path="*" element={<Navigate to="/" replace />} />
					
					<Route element={<MainLogin />}>
						<Route path="/login" element={<Login />} />
						<Route path="/recovery" element={<Forgot />} />
						<Route path="/change-password/:hash" element={<Reset />} />
						<Route path="/2fa" element={<SecondAuth />} />
						<Route path="/2fa/:code/:interimToken" element={<SecondAuth />} />
					</Route>
				</Routes>
			</Router>
		);
	}
}

export default Routing;
